var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancerSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 960 960",
    fill: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#000000",
    strokeWidth: 9.6,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1313_6312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M578.572 684.766C568.468 667.19 555.962 651.092 549.341 632.857C515.385 544.107 578.662 438.194 668.74 415.862C759.603 392.32 866.724 447.61 878.505 545.365C899.837 719.801 687.842 760.526 555.245 768.112C423.27 775.284 290.637 767.679 164.198 726.418C129.146 716.119 62.6024 696.65 84.2344 647.967C103.1 611.788 142.896 635.151 171.506 644.602C303.051 684.487 441.829 701.049 578.572 684.766ZM798.921 566.902C796.526 487.844 676.94 469.817 641.486 539.689C612.697 581.498 632.529 634.352 683.857 641.03C694.086 643.115 705.983 640.875 714.785 645.277C730.39 653.082 741.241 644.728 753.222 638.67C779.224 622.933 797.972 599.807 798.921 566.902Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.757 271.077C502.475 410.672 311.162 642.844 147.093 530.622C61.8835 476.309 61.1135 354.782 129.398 285.752C232.037 185.564 392.989 187.236 527.388 190.568C593.275 193.302 844.002 221.581 863.252 289.503C867.11 306.891 851.651 332.223 832.498 329.247C824.37 327.984 815.176 327.966 808.492 323.984C777.814 305.703 743.703 297.368 709.927 288.037C595.538 256.965 472.557 257.078 355.757 271.077ZM164.487 404.453C163.041 443.452 196.542 470.499 231.206 476.463C283.178 482.191 332.263 429.116 325.039 377.761C316.714 327.716 265.181 317.272 220.673 314.842C184.459 329.405 166.219 366.514 164.487 404.453Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1313_6312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 582,
    fill: "white",
    transform: "translate(80 189)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancerSvgrepoCom);
export default __webpack_public_path__ + "static/media/cancer-svgrepo-com.19e28a92628837d9e3dc79103eb77d6b.svg";
export { ForwardRef as ReactComponent };